<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-11-15 10:32:32
 * @LastEditors: pj
 * @LastEditTime: 2022-11-15 10:40:01
-->
<template>
    <div class="containnerBox">
        <a-card size="small" title="消息推送">
        </a-card>
        <div class="items">
            <a-card size="small" hoverable class="itemCard">
                <img src="@/assets/msg1.svg" alt="">
                <p class="itemTitle">普通消息</p>
                <p class="itemContent">自由选择发送通道，填写消息内容</p>
                <a-button type="primary" @click="changeStatue(2)">发送消息</a-button>
            </a-card>

            <a-card size="small" hoverable class="itemCard">
                <img src="@/assets/msg2.svg" alt="">
                <p class="itemTitle">模板消息</p>
                <p class="itemContent">一次变量传值对所有通道生效，助你一键群发</p>
                <a-button type="primary" @click="changeStatue(3)">发送消息</a-button>
            </a-card>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {
        changeStatue(s) {
            if (2 == s) {
                this.$router.push({ path: 'msgIndex' })
            } else {
                this.message.info('功能暂未开放，请选择发送普通消息')
            }
        },
    },
    components: {},
    mounted() {},
}
</script>
<style scoped>
.items {
    display: flex;
    justify-content: center;
    margin-top: 120px;
}

.itemCard {
    padding: 34px 28px;
    text-align: center;
    width: 240px;
    margin: 20px;
}

.itemCard img {
    margin-bottom: 10px;
}

.itemTitle {
    font-weight: bolder;
    color: #000;
    margin-bottom: 12px;
}

.itemContent {
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 24px;
}

.oprationBox {
    padding: 30px 28px 0 28px;
}
</style>


